import { cn } from '@shared/components/shadcn';
import { RegistrationStepLogo } from '../../../../Logos/Logos';
import { BackButton } from '../BackButton/BackButton';
import type { StepLayoutProps } from './types';

/**
 * Shared layout component for registration steps
 * Reduces repetition of common UI patterns
 */
function StepLayout({
  children,
  title,
  description,
  showBackButton = true,
  showLogo = true,
  dataTrackContainer,
  dataTrackStep,
  dataTrackFeature,
  className = '',
  titleClassName = '',
  'data-testid': dataTestId = '',
  dataImpression,
}: StepLayoutProps) {
  return (
    <div
      className={cn(`w-full flex flex-col flex-1 self-center md:justify-center gap-8 p-6 pt-10 md:p-10 md:max-w-2xl ${className}`)}
      data-track-container={dataTrackContainer}
      data-track-step={dataTrackStep}
      data-testid={dataTestId}
      data-track-feature={dataTrackFeature}
      data-impression={dataImpression}
    >
      {/* Back button */}
      {showBackButton && <BackButton />}

      {/* Brand step logo */}
      {showLogo && <RegistrationStepLogo className="rounded-sm md:hidden" />}

      {/* Title + optional description */}
      {(title || description) && (
        <div className={cn('flex flex-col gap-2', description && 'mb-5 md:mb-0')}>
          {title && <h4 className={cn('md:heading-3', !description && 'mb-5 md:mb-0', titleClassName)}>{title}</h4>}
          {description && <p className="text-foreground-subtle text-sm leading-relaxed">{description}</p>}
        </div>
      )}

      {/* Step content */}
      {children}
    </div>
  );
}

export { StepLayout };
